import gql from "graphql-tag"

export const GET_ZAVER_CONFIG = gql`
  query getZaverConfig($id: ID!) {
    getZaverConfig(id: $id) {
      id
      created
      updated
      baseUrl
      credentials {
        apiKey
        callbackApiKey
      }
    }
  }
`
